<template>
    <div class="xtxx">
<!-- 户-物业费列表页 -->
       
<div class="content">


           <div class="allsel" v-if="selectItem.length>0" >
                <div class="sels">
                                    <div v-for="(item,index) in selectItem" :key="index">
                    {{item.typeName}}
                    <span v-if="index!=(selectItem.length-1)">,</span>
                </div>
                </div>
                <van-button type="primary" size="small" @click="allJf()">批量缴费</van-button>
        </div>


            <van-pull-refresh v-model="refreshing1" @refresh="onRefresh1" >
                <van-list
                    v-model="loading1"
                    :finished="finished1"
                    finished-text="没有更多了"
                    @load="onLoad1"
                >


                 <van-checkbox-group  v-model="selectItem" @change="handleChg" class="vgdv">
                    <div class="pj" v-for="(item,index) in list1" :key="index">
                        <!-- <img src="../../assets/tsbx/ls.png" alt=""> -->
                    <div class="xz" style="width:20%" v-if="item.type!=5">
                                                                            <van-checkbox :name="item"
                          class="head-radio" :disabled="item.isPay=='已缴'"
                          checked-color="#4293D9"></van-checkbox>

                    </div>
                    <div class="xz" style="width:20%" v-else></div>

                        <div class="xq">
                            <span> {{item.typeName}}</span>
                            <span v-if="houseName">{{houseName}}</span>
                            <span v-else>{{item.villageName}}{{item.address}}</span>
                            <button class="dpj1" v-if="item.type==5&&item.isPay=='未缴'" @click="goxq(item.id,item.type,item.typeName,item.canPay)">去缴费</button>
                            <button class="dpj1" v-if="item.type!=5&&item.isPay=='未缴'" @click="goxq(item.id,item.type,item.typeName,item.canPay)">未缴</button>
                            <button class="dpj1" v-if="item.isPay=='已退款'" @click="goxq(item.id,item.type,item.typeName,item.canPay)">已退款</button>
                            <button class="dpj" v-if="item.isPay=='已缴'" @click="goxq(item.id,item.type,item.typeName,item.canPay)">已缴</button>


                          
                        </div>





                    </div>


                                </van-checkbox-group>

                </van-list>
            </van-pull-refresh>


            


</div>


       
    </div>
</template>
<script>
import Vue from 'vue';
import { mapState, mapMutations } from "vuex";
import { Checkbox, CheckboxGroup,Button,Toast} from "vant";

	Vue.use(Toast);
	Vue.use(Button);
	Vue.use(Checkbox);
	Vue.use(CheckboxGroup);
export default {
    data() {
        return {
            active:0,
            tp:'',
            search:'',
            active:'',
            list1:[],
            list2:[],
            houseName:'',
            loading1: false,
			loading2: false,
            finished1: false,
			finished2: false,
            refreshing1: false,
			refreshing2: false,
            currpage1:0,//待签收页码
            currpage2:0,//待办结页码
            selectItem: [],
            allsel:[],
            selJsonArr:[]
        }
    },
    computed: {
 	...mapState(['userInfo','identity','houseId','isactive']),
 },
    mounted() {
        this.tp = this.$route.query.tp
        this.onLoad1()
        // this.reload()
        // console.log(this.userInfo)
        this.houseName=sessionStorage.getItem('houseName')
    },
    methods: {

            allJf(item) {

      var that=this

    var totalArr=that.selectItem.map((item,index)=>{
        return Number(item.actually||0)
    })
    var sum=0
    totalArr.map((item,index)=>{
        sum+=item
    })

        var typeArr=that.selectItem.map((item,index)=>{
            return item.typeName
        })
      let data = new FormData();
      var jsonData={
            id:that.$route.query.id,
            totalFee:sum,
            validTime:'10000',
            backUrl:'https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/index.html#/wyfw/jflist',
            proInfo:typeArr.toString(),
            attach:'',
            shopId:that.list1[0].villageId,
            operatorId:'',
            outTradeNo:that.$route.query.id,
            extf1d1:'',
            extf1d2:'',
            extf1d3:'',
            type:4,
            remarks:that.selJsonArr
				}

      for(let key in jsonData) {
        data.append(key,jsonData[key]);
      }
      console.log(jsonData)
      this.$axios
        .post("/api/v1/jSbank/atPay", data)
        .then((res) => {
          console.log("🚀 ~ file: wyflist.vue:157 ~ .then ~ res:", res)

          if(res.payUrl){ 
            window.location.href = res.payUrl;
          }else{
            that.$toast.fail(res.message||'暂不支持合并付款！')
          }
        });




    },


        handleChg(v){
            var that=this
            console.log(v)
            this.selectItem=v
            var selArr=v.map((item,index)=>{
                return{
                    type:item.type,
                    money:item.actually
                }
            })
            that.selJsonArr=JSON.stringify(selArr)
        },
        onSearch(val) {

        (this.currpage1 = 0),
        (this.refreshing1 = false),
        (this.list1 = []),
        this.getdata();
            
			},
        goxq(id,type,typeName,canpay){
            var isNojf = this.list1.slice(0,2).findIndex( item =>{
                if (item.isPay== '未缴'){
                    return true
                }
            })
            if(type==3&&!canpay){
                this.$toast.fail('请先确认物业服务费、代收代交费已结清！')
                return
            }else if(type==5){
                // 人防车位费直接跳转详情页单独缴费
                this.$router.push({ path: "/wyfw/jfdetail", query: {id:id,type:type,typeName:typeName} });
                return
            }else{
                this.$router.push({ path: "/wyfw/jfdetail", query: {id:id,type:type,typeName:typeName} });//进入物业-缴费详情页 
            }
            

            
        },
        getdata(name){


                
                let data = new FormData();
                 var jsonData = {};
                     jsonData = {
                         id:this.$route.query.id
                 }
                       for (let key in jsonData) {
         data.append(key, jsonData[key]);
       }
                this.$axios.get('/api/v1/wygl/propertyPayment/viewListById?id='+this.$route.query.id).then(res => {
                console.log("🚀 ~ file: wyflist.vue:112 ~ this.$axios.get ~ res:", res)
          if (res) {
            this.list1 = res;

          } 

          this.loading1 = false;
          this.refreshing1 = false;

          if (!res.data|| res.data.length < 10) {
            this.finished1 = true;
          } else {
            this.currpage1++;
            this.finished1 = false;
          }
                });
            
            
        },
        onLoad1(){
           if (this.refreshing1) {
				// 清空列表数据
				this.currpage1 = 0;
				this.list1 = [];
				this.refreshing1 = false;
           }
           this.getdata(this.$route.query.tp)
		   
        },
        onRefresh1() {
			  this.finished1 = false;
			  // 重新加载数据
			  // 将 loading 设置为 true，表示处于加载状态
			  this.loading1 = true;
			  this.onLoad1();
        },
		onLoad2(){
		   if (this.refreshing2) {
				// 清空列表数据
				this.currpage2 = 0;
				this.list2 = [];
				this.refreshing2 = false;
		   }
		   this.getdata(this.$route.query.tp)
		},
		onRefresh2() {
			  this.finished2 = false;
			  // 重新加载数据
			  // 将 loading 设置为 true，表示处于加载状态
			  this.loading2 = true;
			  this.onLoad2();
		},
        
    },
}
</script>
<style lang="less">
	.orange{
		color: rgb(240, 182, 49);
	}
    	.blue{
		color: #28aff6;
	}
    .content{
          height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
    }
    .vgdv{
        width: 100%;
    }
    .xtxx{
        height: calc(100% - 50px);
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        align-items: center;
        .van-tabs{
            height: 100%;
        }
        .van-pull-refresh{
            height: 100%;
        }
        .van-tab__pane{
            height: 100%;
        }
        .van-tabs__content{
            height: calc(100vh - 140px);
        }
        .van-pull-refresh__track{
            overflow: hidden;
            overflow-y: scroll;
        }
        .wdxx{
            margin: 26px 10px 26px 10px;
        }
        .biaoqian{
            height: 100%;
            width: 100%;
        }
        .xtxxc{
            width: calc(100% - 6%);
            height: 100%;
        }
        .pj{
            display: flex;
            width: 94%;
            // height: 100px;
			padding:14px 5px ;
            border-radius: 10px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            box-shadow: 0px 0px 5px #e6e6e6;
            margin-top: 10px;
            img{
                margin-left: 2%;
                height: 80px;
                width: 80px;
            }
            .xq{
                height: 100%;
                width: 92%;
                display: flex;
                flex-direction: column;
                position: relative;
                span{
                    width:70%;
                }
                span:nth-child(1){
                    font-weight: bold;
                }
                span:nth-child(2){
                    margin-top: 5px;
                    color: #999999;
                }
                span:nth-child(3){
                    margin-top: 5px;
                    color: #999999;
                }
                .dpj{
                    height: 25px;
                    top: calc(50% - 15px);
                    position: absolute;
                    right: 2%;
                    border: 1px solid #00d2ff;
                    color: #00d2ff;
                    background-color: transparent;
                    border-radius: 30px;
                    font-size: 15px;
                }
                .dpj1{
                    height: 25px;
                    top: calc(50% - 15px);
                    position: absolute;
                    right: 2%;
                    border: 1px solid rgb(240, 182, 49);
                    color: rgb(240, 182, 49);
                    background-color: transparent;
                    border-radius: 30px;
                    font-size: 15px;
                }
            }
        }
        .search{
            width: 100%;
            height: 50px;
            display:block;
        }
        .allsel{
            width: 100%;
            height: 50px;
            display:block;

            display: flex;
            justify-content: space-between;
            align-items: center;
            .sels{
                            border: 1px solid #00d2ff;
            border-radius: 5px;
                width: 75%;
                height: 80%;
                line-height: calc(50px * 0.8);
                display: flex;
                justify-content: start;
                align-self: center;
            }
        }
        .van-tabs__line{
            background-color: #28aff6;
            width: 90px;
            border-radius: 5px;
        }
        .van-list{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .wdxxitem{
            color: white;
            margin-top: 20px;
            font-weight: 600;
            height: 70px;
            width:90%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #b7b7b7;
            border-radius: 10px;
        }
        ::-webkit-scrollbar{
            display: none;
        }
    }
</style>